<template>
  <div>
    <b-modal
      v-if="job"
      ref="modal"
      centered
      hide-footer
      size="lg"
      static
      class="send-message-form modal-form"
    >
      <b-img
        slot="modal-header-close"
        :src="require('@/assets/icons/x-b.svg')"
        width="45"
        height="30"
      ></b-img>

      <h2 class="page-title text-center">{{ owner.full_name }}</h2>

      <b-form class="form mt-5" @submit.prevent="onSubmit">
        <div class="form__section mb-0">
          <b-form-group class="message-textarea">
            <b-textarea v-model="form.message"></b-textarea>
            <div class="text-right">
              <b-button
                type="submit"
                variant="primary"
                :disabled="form.$busy"
                class="btn--xs"
              >
                <b-spinner small v-if="form.$busy"></b-spinner>
                Send</b-button
              >
            </div>
          </b-form-group>
          <div class="message-email d-flex flex-row align-items-center">
            <custom-checkbox v-model="form.email_copy"></custom-checkbox>
            <label @click="toggleEmail">
              Email me a copy of this message to:
              <span>{{ user ? user.email : '' }}</span>
            </label>
          </div>
        </div>
      </b-form>
    </b-modal>
    <b-modal
      v-model="response"
      centered
      class="response-modal modal-confirmation text-center p-3"
      hide-footer
      static
    >
      <b-img
        slot="modal-header-close"
        :src="require('@/assets/icons/x-b.svg')"
        width="45"
        height="30"
      ></b-img>

      <div
        class="d-flex flex-column justify-content-between align-items-center text-center"
      >
        <h2>{{ owner.full_name }}</h2>

        <b-img
          :src="require('@/assets/images/alert-success.svg')"
          width="150"
          height="150"
          class="modal-confirmation__icon"
        ></b-img>

        <p class="response-content mb-0 mt-4">
          Your message has successfully been sent to {{ owner.full_name }}.
        </p>
        <p class="mb-4 mt-0">
          Communicate directly using My messages section so you don't need to
          rely in SMS or email.
        </p>
        <div
          class="modal-confirmation__footer modal-confirmation__footer--single modal-confirmation__footer--normal"
        >
          <router-link :to="{ name: 'user.messages-page' }">
            <b-button variant="outline-primary">
              View my messages
            </b-button>
          </router-link>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Review form
 * ==================================================================================
 **/

import { mapState } from 'vuex'
import Job from '@/models/Job'
import Form from '@/utils/form'
import CustomCheckbox from '@/components/inputs/CustomCheckbox'

export default {
  components: {
    CustomCheckbox
  },
  props: {
    job: {
      type: [Job, Object],
      validator: function(value) {
        return value.owner
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    owner() {
      return this.job.owner
    }
  },
  data: function() {
    return {
      response: false,
      form: new Form({
        message: null,
        email_copy: false
      })
    }
  },
  methods: {
    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      await new Promise(resolve => {
        setTimeout(() => {
          this.form.$setLoading(false)
          this.close()
          this.response = true
          resolve()
        }, 1000)
      })
    },

    toggleEmail() {
      this.form.email_copy = !this.form.email_copy
    },

    show() {
      this.response = false
      this.$refs.modal.show()
    },
    close() {
      this.$refs.modal.hide()
    }
  },
  created() {
    this.form.message = `Hi, I'm interested in your "${this.job.name}" on the app. When is a good time to inspect it and do you know?`
  }
}
</script>
<style scoped lang="scss">
.send-message-form /deep/ {
  .message-textarea {
    padding: 1rem;
    border-radius: 0.25rem;
    border: 1px solid var(--input-border-color);

    textarea {
      font-size: 1.15rem;
      line-height: 1.4rem;
      height: 150px;
      min-height: auto;
      padding: 0;
      border: none;
    }

    button {
      width: 125px;
    }
  }

  .message-email {
    label {
      font-size: 1.15rem;
      line-height: 1.4rem;
      margin-bottom: 0;

      span {
        font-weight: 900;
      }
    }
  }
}

.response-modal /deep/ {
  p {
    max-width: 500px;
  }
}
</style>
